export default "__VITE_ASSET__4cd68cce__"